import { useState } from "react"
import { ConversationContext } from "@/types"

import { PlaygroundChatContext, PlaygroundChatContextType } from "./types"

const ChatContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [conversationContext, setConversationContext] =
    useState<ConversationContext | null>(null)

  return (
    <PlaygroundChatContext.Provider
      value={
        {
          conversationContext,
          setConversationContext,
        } as PlaygroundChatContextType
      }
    >
      {children}
    </PlaygroundChatContext.Provider>
  )
}

export default ChatContextProvider
